import * as React from 'react';
import { FormSubSections, FormSectionElements, FormSections, LOVValues } from '../entities/formTemplateDataType';
import { User } from '../entities/User';
import axios from 'axios';
import URLUtils from '../utilities/URLUtils';
import Utils from '../utilities/Utils';
import { ElementDictionary } from '../entities/ElementDictionary';
import { Button, Calendar, Checkbox, InputNumber, Column, DataTable, Dropdown, InputMask, InputText, InputTextarea } from 'primereact';
import DataUtils from '../utilities/DataUtils';


interface Props {
  field?: any;
  isEng: boolean;
  activeSubSection: FormSubSections;
  user: User;
  topEntity;
  editable: boolean;
  usedByDesigner: boolean
  callback;
}

interface State {
  records: any;
  confirmVisible: boolean;
}

export class ElementListComponent extends React.Component<Props, State> {
  records;
  parentField: FormSectionElements = this.props.activeSubSection.parent as FormSectionElements;
  preserved;
  ele;
  editable: boolean;
  visibleColumns: any;
  tableData;

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    this.records = prevProps["field"].Value;

    if(!DataUtils.compareArraysOfObjects(this.records, this.state.records)){
      this.setState({records:this.records});
      this.tableData = this.records;
    }

    if (prevProps.isEng !== this.props.isEng) {
      this.checkSummaryValues();
    }
    //console.log(this.records);
    //console.log(this.state.records);
    //console.log(prevState);
    //console.log(this.props.activeSubSection.parent['Value'])
  }

  readonly TOTAL_COLUMN_VALUE = "Totals:"

  constructor(props: Props) {
    super(props);
    let api = this.props.activeSubSection.Api;

    this.records = this.parentField.Value || [];

    if (Array.isArray(this.records)) {
      this.state = { records: this.records, confirmVisible: false }
    } else {
      let arr = [];
      arr.push(...this.records);
      this.state = { records: arr, confirmVisible: false }
    }


    if (api) {
      axios.get(URLUtils.concatUrls(api), { withCredentials: true }).then(
        response => {
          let data = response.data.map(item => item.body);
          this.tableData = data;
          this.setState({
            records: data
          })
        });
    }

    this.checkSummaryValues();
  }  

  checkSummaryValues= () => {
    if (this.props.activeSubSection?.parent.summaryFromFlow && this.props.activeSubSection.ListOfFormSectionElements.length) {
      this.tableData = this.getExpectedValues();
      this.setState({ records: this.tableData });
      if (this.props.field) {
        this.props.field.Value = this.tableData;
      }
    }
  }

  getExpectedValues = (): any[] =>{
    let sections = this.props.activeSubSection.parent;
    while (sections && !sections.ListOfFormSections) {
      sections = sections.parent;
    }

    if (!sections) return [];
    let correctedAnswers = 0;
    const quizValues = sections.ListOfFormSections.reduce((sum, section) => {
      const values = this.getExpectedValuesFromElements(section);
      sum = sum.concat(values);
      return sum;
    }, []);
    return quizValues;
  }

  getTableColumns = () => {
    return this.props.activeSubSection.ListOfFormSectionElements?.map(
      col => (col.LoadBindBase ? col.LoadBindBase + '.' : '') + col.LoadBindName
    );
  }

  getExpectedValuesFromElements = (section: FormSections): any[] => {
    return section.ListOfFormSubSections?.reduce((sum, subSec) => {
      const elements = subSec.ListOfFormSectionElements?.filter(element => element.Datatype === "RadioButton");
      if (elements.length) {
        const cols = this.getTableColumns();
        const row = elements.reduce((sum, element) => {
          if (!sum[cols[0]]) {
            sum[cols[0]] = this.props.isEng? element.ENUTitle : element.FRATitle;
          }
          if (element.Value) {
            const value = element.ListOfLOVValues?.filter(val => val.code === element.Value);
            if (value?.length) {
              const sumVal = sum[cols[1]] ? sum[cols[1]].trim() + ', ' : '';
              if (sum[cols[1]]) {
                sum[cols[1]] = sum[cols[1]].trim() + ', ' + ((this.props.isEng ? value[0].description : value[0].FRADescription) ?? '');
              } else {
                sum[cols[1]] = (this.props.isEng ? value[0].description : value[0].FRADescription) ?? '';
              }
            }
          }

          const values = element.ListOfLOVValues?.filter(val => element?.ListOfExpectedValues?.includes(val.code));
          if (values?.length) {
            const val = values.map(val =>  ((this.props.isEng? val.description : val.FRADescription) || (this.props.isEng ? 'Value is not defined in Englsh' : "La valeur n'est pas définie en français")));
            sum[cols[2]] = (sum[cols[2]] ? sum[cols[2]] + ', ' : '') + val.join(', ');
          } else {
            sum[cols[2]] = this.props.isEng ? 'Multiple answers applicable' : 'Plusieurs réponses applicables';
          }

          return sum;
        }, {});

        sum.push(row);
      }
      return sum;
    }, []) ?? [];
  }

  getCustomValues = (val: string, options?: {label: string, labelFRA: string, val: string}[]): string => {
    if (val === options?.[0]?.val) {
      return this.props.isEng ? options[0].label : options[0].labelFRA;
    }
    return '';
  }

  OnAddClick = (e: any) => {
    let updatedRecords: any[] = [...this.state.records];
    //console.log(this.parentField.subSectionList[0])
    let newObj = {};
    this.parentField.subSectionList[0].ListOfFormSectionElements.forEach(p => {
  
      if(p.Datatype=="Checkbox"){
        newObj[p.LoadBindName]="N" // we have to pass Y/N to Siebel
      } else {
         newObj[p.LoadBindName] = "";
      }
    });

    if (this.parentField.HasTotalColumn=='Y') {
      newObj['totalCost'] = null;
    }
    //console.log(newObj)
    updatedRecords.push(newObj);

    updatedRecords = this.deleteThenAdd(updatedRecords)
    this.setState({ records: updatedRecords });
    this.tableData = updatedRecords;

    //console.log(updatedRecords);
    this.parentField.Value = updatedRecords;
  }

  deleteThenAdd = (updatedRecords) => {

    let firstColumn;
    if (this.parentField.HasSummaryRow) {
      let newObj = {};
      this.parentField.subSectionList[0].ListOfFormSectionElements.forEach((p, index) => {

        if (this.parentField.HasTotalColumn=='Y') {
          newObj['totalCost'] = null;
        }

        if (index == 0) {
          newObj[p.LoadBindName] = this.TOTAL_COLUMN_VALUE;
          firstColumn = p.LoadBindName;
        }
        else {
          newObj[p.LoadBindName] = null;
        }
      });

      let withoutSummary = updatedRecords.filter(p => p[firstColumn] !== this.TOTAL_COLUMN_VALUE);

      withoutSummary.push(newObj);
      updatedRecords = withoutSummary;
    }

    return updatedRecords;
  }

  OnCalcTotal = () => {
    let totals = {};
    let updatedRecords: any[] = [...this.state.records];

    let hasSummaryRow = false;
    if (this.parentField.Value.length > 0) {
      let lastObj = this.parentField.Value[this.parentField.Value.length - 1];

      for (let key in lastObj) {
        if (lastObj[key] == this.TOTAL_COLUMN_VALUE) {
          hasSummaryRow = true;
        }
      }
    }

    if (!hasSummaryRow) {
      updatedRecords = this.deleteThenAdd(updatedRecords);
      this.setState({ records: updatedRecords });
      this.tableData = updatedRecords;
      this.parentField.Value = updatedRecords;
    }

    this.parentField.Value.forEach((invoice) => {
      for (let key in invoice) {
        if (typeof invoice[key] === 'number') {
          totals[key] = (totals[key] || 0) + invoice[key];
        }
      }
    });

    console.log(totals);

    let summaryRow = this.getSummryRow();

    if (summaryRow) {
      for (let key in totals) {
        if (summaryRow.hasOwnProperty(key)) {
          summaryRow[key] = totals[key];
        }
      }
    }
    this.setState({ records: updatedRecords });
    this.tableData = updatedRecords;
  };

  onDropdownChange = (e) => {
    let updatedRecords: any[] = [...this.state.records];
    let val = null;

    if (e.value) {
      val = e.value;
    } else {
      let elem = e.originalEvent ? e.originalEvent.target : e.target;
      val = elem.value;
    }

    this.state.records[this.preserved.rowIndex][this.preserved.field] = val;

    updatedRecords[this.preserved.rowIndex][this.preserved.field] = val;
    this.setState({ records: updatedRecords });
    this.tableData = updatedRecords;

    // this.props.topEntity[this.parentField.LoadBindBase][this.parentField.LoadBindName] = updatedRecords;
    this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.LoadBindName == this.preserved.field)[this.preserved.rowIndex].Value = val;

  }

  onEditorValueChange = (props, e) => {
    let updatedRecords: any[] = [...this.state.records];
    let field = props.field;
    if (field.indexOf(',') > -1) {
      field = field.split(",")[1];
    }

    let val;
    if (e.value) {
      val = e.value;
    } else {
      let elem = e.originalEvent ? e.originalEvent.target : e.target;
      val = elem.value;
    }

    this.state.records[this.preserved.rowIndex][this.preserved.field] = val;
    updatedRecords[props.rowIndex][field] = val;

    let ele = this.parentField.subSectionList[0].ListOfFormSectionElements.filter(p => p.LoadBindName == field)[0];
    if (ele.ValidateCompareMethod != null) {
      if (ele.ValidateCompareMethod == '>') {
        if (new Date(this.state.records[this.preserved.rowIndex][ele.LoadBindName]) < new Date(this.state.records[this.preserved.rowIndex][ele.ValidateCompareField])) {
          ele.Valid = false;
        }
      }
    }
    this.tableData = updatedRecords;
    this.setState({ records: updatedRecords }, (() => {
      //if(this.props.topEntity[this.parentField.LoadBindBase]==null){
      //   this.props.topEntity[this.parentField.LoadBindBase]={}
      //  }

      //  this.props.topEntity[this.parentField.LoadBindBase][this.parentField.LoadBindName] = updatedRecords;
      this.parentField.Value = updatedRecords;
    }));

    this.calcSummary(props);

  }

  calRowTotal = (props) => {
    let total = 0;

    let rowData = this.state.records[props.rowIndex];

    for (let key in rowData) {
      if (!isNaN(parseInt(rowData[key])) && key != 'totalCost')
        total += Number.parseFloat(rowData[key]);
    }

    rowData.totalCost = total;
    let summaryRow;
    for (var record of this.state.records) {
      for (let key in record) {
        if (record[key] == this.TOTAL_COLUMN_VALUE)
          summaryRow = record;
      }
    }

    let summaryTotal = 0
    //calculate summary row sum
    for (let key in summaryRow) {
      if (!isNaN(parseInt(summaryRow[key])) && key != 'totalCost')
        summaryTotal += Number.parseFloat(summaryRow[key]);
    }

    if (summaryRow != null && summaryRow['totalCost'] != null)
      summaryRow['totalCost'] = summaryTotal;
  }

  calcSummary = (props) => {
    console.log(props)
    let field = props.field;
    let summaryRow = this.getSummryRow();
    if (summaryRow != null && summaryRow[field] != this.TOTAL_COLUMN_VALUE) {
      summaryRow[field] = this.getTotal(props);
    }
    this.calRowTotal(props);
  }

  getTotal = (props) => {
    let total = 0;
    let field = props.field;
    //console.log(this.state.records)
    //console.log(props)
    for (let i = 0; i < this.state.records.length - 1; i++) {
      let p = this.state.records[i];
      if (!isNaN(p[field])) {
        //console.log(p[field])
        total += Number.parseFloat(p[field]);
      }
    }

    return total;
  }

  getSummryRow = () => {
    let summaryRow;
  
    if (this.parentField.HasSummaryRow=='Y') {
  
      this.state.records.forEach(rec => {

        for (let key in rec) {
          if (rec[key] == this.TOTAL_COLUMN_VALUE) {
            summaryRow = rec;
          }
        }
      })
    }

    return summaryRow;
  }



  onCheckboxValueChange = (props, e) => {
    let updatedRecords: any[] = [...this.state.records];
    let field = props.field;
    let elem = e.target;
    let val = elem.checked;
    this.state.records[this.preserved.rowIndex][this.preserved.field] = val;

    updatedRecords[props.rowIndex][field] = val;
    this.tableData = updatedRecords;
    this.setState({ records: updatedRecords });

    this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.LoadBindName == this.preserved.field)[this.preserved.rowIndex].Value = val;
    this.parentField.Value = updatedRecords;
  }

  onEditorDateChange = (props, e) => {
    let updatedRecords: any[] = [...this.state.records];
    let field = props.field;
    console.log(e);
   
     let val =Utils.getFormattedDate( e.value);
    
    // this.state.records[this.preserved.rowIndex][this.preserved.field] = val;

    updatedRecords[props.rowIndex][field] =val;
    this.tableData = updatedRecords;
    this.setState({ records: updatedRecords });

    this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.LoadBindName == this.preserved.field)[this.preserved.rowIndex].Value = val;
    this.parentField.Value = updatedRecords;
  }

  loadingBody = [];

  inputTemplateTooltip = (localProps, column) => {
    let sub;

    let subList = this.loadingBody.find(p => p.columnId == column.id);
    if (subList && subList.length > 0) {
      sub = subList[0];
    }
    return (<div style={{ display: 'flex' }}>
      <div>
        <label key={'fdIpt_' + column.Id}>{localProps[column.field]}
        </label>
      </div>

      <div style={{ display: sub && localProps[column.field] == sub.DisplayTooltipValue ? 'block' : 'none' }}>
        <label htmlFor={'fdIpt_' + column.Id} className="ontario-label" >
          <i title={sub?.TooltipENU} className="pi pi-info-circle"></i>
        </label>
      </div>
    </div>)
  }

  inputTemplate = (localProps, column) => {

    let eles = this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.LoadBindName == column.field);
    let ele: FormSectionElements;
    if (eles.length > 0) {
      ele = eles[0];
    }

    let numOfRow = 5;
    let maxLength = 500;
    let lengthAndRow = "";

    if(ele){
      lengthAndRow = ele.Length;
    }

    this.editable =
      ele.Editable == 'Y' &&
      this.props.editable &&
      (localProps.editable == null || localProps.editable != null && localProps.editable)
      && (!localProps[ele.EnabledByField] || (localProps[ele.EnabledByField] && ele.EnabledByFieldValue.indexOf(localProps[ele.EnabledByField]) > -1));
    //console.log("This is local props ", localProps)
   
    switch (ele.Datatype) {
      case 'Number':
        if (this.editable && !this.isSummaryRowOnView(localProps, this.parentField.Value)) {
         return <div>
            <InputText type="text" style={{ width: '100%' }} keyfilter="num" value={localProps[column.field] ? localProps[column.field] : ''} ></InputText>
          </div>;
        } else {
          return <div>
            {localProps[column.field] ? localProps[column.field] : null}
          </div>
        }

      case 'Currency':
        if (this.editable && !this.isSummaryRowOnView(localProps, this.parentField.Value)) {
          return <div style={{ textAlign: 'right' }}>
            <InputNumber mode='currency' style={{ textAlign: 'right' }} currency="USD" locale="en-US" value={localProps[column.field] ? localProps[column.field] : null} ></InputNumber>
          </div>;
        } else {
          return <div style={{ textAlign: 'right' }}>
            {localProps[column.field] ? Number(localProps[column.field]).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : null}
          </div>
        }
      case "Text":

        if ((this.editable || this.props.usedByDesigner) && !this.isSummaryRowOnView(localProps, this.parentField.Value) && localProps[column.field] != this.TOTAL_COLUMN_VALUE) {
          return <div>
            <InputText type="text" disabled={this.props.usedByDesigner ? false : !this.editable} style={{ width: '100%' }} value={localProps[column.field] ? localProps[column.field] : ''}  ></InputText>
          </div>;
        } else {
          return <div>
            <label>{localProps[column.field]}</label>
          </div>
        }
      case "Checkbox":
        let ifChecked=false;
        if(typeof  localProps[column.field] == 'boolean'){
          ifChecked=localProps[column.field]
        }

        if (typeof  localProps[column.field] == 'string'){
          ifChecked=localProps[column.field]=='Y';
        }
        if (this.editable) {
          return <div>
            <Checkbox checked={ifChecked} />
          </div>
        } else {
          return <div>
            {localProps[column.field] ? <i className="pi pi-check"></i> : null}
          </div>
        }
      case "Date":
        if (this.editable && !this.isSummaryRowOnView(localProps, this.parentField.Value)) {
          return <div style={{ border: ele.Valid == true || ele.Valid == null ? '' : 'dashed red' }} title={ele.Valid == false ? ele.ENUTitle + ' must be ' + ele.ValidateCompareMethod + ' ' + ele.ValidateCompareField : null}>
            <Calendar value={localProps[column.field] ? new Date(localProps[column.field]) : null}  ></Calendar>
          </div>
        } else {
          return <div>
            {localProps[column.field] ? new Date(localProps[column.field]).toLocaleDateString() : null}
          </div>
        }
      case 'MultiText':

        if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
          let arr = lengthAndRow.split(",");
          numOfRow = parseInt(arr[0].toString(), 10);
          maxLength = parseInt(arr[1].toString(), 10);
        }
        if ((this.editable || this.props.usedByDesigner) && !this.isSummaryRowOnView(localProps, this.parentField.Value)) {
          return <div>
            <InputTextarea readOnly={this.props.usedByDesigner ? false : !this.editable} style={{ width: '100%' }} maxLength={maxLength} rows={numOfRow} value={localProps[column.field] ? localProps[column.field] : ''} />
          </div>
        }
        else {
          return <div style={{ whiteSpace: 'pre-wrap' }}>
            {localProps[column.field]}
          </div>
        }
      case "History":

        if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
          let arr = lengthAndRow.split(",");
          numOfRow = parseInt(arr[0].toString(), 10);
          maxLength = parseInt(arr[1].toString(), 10);
        }

        let fields = column.field.split(",");

        if (this.editable) {
          return <div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{localProps[fields[0]]}</div>
            <p></p>
            <div>
              <InputTextarea style={{ width: '100%' }} maxLength={maxLength} rows={numOfRow} value={localProps[column.field] ? localProps[column.field] : ''} />
            </div>
          </div>
        }
        else {
          return <div style={{ whiteSpace: 'pre-wrap' }}>{localProps[fields[0]]}</div>
        }
      case "Dropdown":
        let lovOptions = ele.ListOfLOVValues?.filter(p => p.FilterField != null && localProps[p.FilterField] == p.FilterValue);

        if (lovOptions?.length == 0) {
          lovOptions = ele.ListOfLOVValues?.filter(p => p.FilterField == null);
        } else {
          lovOptions = ele.ListOfLOVValues?.filter(p => p.FilterValue != null && localProps[p.FilterField] == p.FilterValue);
        }

        if (this.editable) {
          return <div style={{ width: '100%' }}>
            <Dropdown aria-label={lovOptions.map(p => p.description)} className='within-table' options={lovOptions} style={{ width: '100%' }} optionLabel="description" optionValue="code" value={localProps[column.field] ? localProps[column.field].toString() : null} />
          </div>
        } else {
          if (localProps[column.field]) {
            let optionsFound = lovOptions.filter(p => p.code == localProps[column.field].toString());
            if (optionsFound.length > 0) {
              return <div style={{ whiteSpace: 'pre-wrap', borderStyle: 'none' }}>{optionsFound[0].description}</div>
            } else {
              return <div> <InputText type="text" readOnly style={{ width: '100%', borderStyle: 'none', zIndex: -1 }} value={localProps[column.field]}></InputText></div>
            }
          } else {
            return null;
          }
        }
      default:
        return <div>
          <InputText type="text" style={{ width: '100%' }} value={localProps[column.field]}></InputText>
        </div>;
    }
  }

  deleteTemplate = (localProps, column) => {
    if (this.isSummaryRowOnView(localProps, this.parentField.Value))
      return null;

    return (
      <div style={{ width: '20px' }}>
        <i className="pi pi-trash" style={{ color: 'slateblue', cursor: 'pointer' }} onClick={(e) => {

          let updatedRecords: any[] = [...this.state.records];
          updatedRecords.splice(column.rowIndex, 1);
          this.tableData = updatedRecords;
          this.setState({ records: updatedRecords });
          this.props.activeSubSection.parent["Value"].splice(column.rowIndex, 1);

          //this.props.callback(this.props.activeSubSection.parent);
        }}></i>
      </div>
    )

  }

  onCellEditComplete = (e) => {
    console.log("On complete: ", e)
    let { rowData, newValue, field, originalEvent: event } = e;

    rowData[field] = newValue;
  }

  textEditor = (props) => {
    console.log("This is row Data: ", props)
    this.preserved = props;
    let eles = this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.LoadBindName == props.field);
    if (eles.length > 0) {
      this.ele = eles[0];
    }
    let numOfRow = 5;
    let maxLength = 500;
    let lengthAndRow = this.ele.Length;
    this.editable = this.ele.Editable == 'Y' && this.props.editable
      && (this.state.records[props.rowIndex].editable == null || (this.state.records[props.rowIndex].editable != null && this.state.records[props.rowIndex].editable))
      && (this.ele.EnabledByField == null
        || (this.ele.EnabledByField != null && this.ele.EnabledByFieldValue.indexOf(this.state.records[props.rowIndex][this.ele.EnabledByField].toString()) > -1));


    if (this.ele.parent && this.ele.parent.ListOfFormSectionElements) {
      let resetFields = this.ele.parent.ListOfFormSectionElements.filter(p => p.ScriptTriggerField === this.ele.LoadBindName && p.ScriptTriggerFieldValue === this.state.records[props.rowIndex][props.field]);

      if (resetFields) {
        const ele = resetFields[0];

        if (ele && ele.Script) {
          eval(ele.Script);
        }

      }
    }

    switch (this.ele.Datatype) {
      case 'Number':
        if (this.editable && !this.isSummaryRowOnClick(props, this.parentField.Value))
          return <InputText type="text" readOnly={false} aria-label="hardcoded" value={this.state.records[props.rowIndex][props.field]} maxLength={parseInt(this.ele.Length)} keyfilter="num" style={{ width: '100%' }} onChange={(e) => this.onEditorValueChange(props, e)} />;
        else
          return <div>{this.state.records[props.rowIndex][props.field]}</div>
      case 'Text':
        if ((this.editable || this.props.usedByDesigner) && !this.isSummaryRowOnClick(props, this.parentField.Value))
          return <InputText type="text" disabled={this.props.usedByDesigner ? false : !this.editable} value={this.state.records[props.rowIndex][props.field]} maxLength={parseInt(this.ele.Length)} style={{ width: '100%' }} onChange={(e) => this.onEditorValueChange(props, e)} />
        else
          return <div>{this.state.records[props.rowIndex][props.field]}</div>
      case 'Dropdown':
        // const lovOptions = ele.ListOfLOVValues;
        let lovOptions = this.ele.ListOfLOVValues.filter(p => p.FilterField != null && this.state.records[props.rowIndex][p.FilterField] == p.FilterValue);
        if (lovOptions.length == 0) {
          lovOptions = this.ele.ListOfLOVValues.filter(p => p.FilterField == null);
        } else {
          lovOptions = this.ele.ListOfLOVValues.filter(p => p.FilterValue != null && this.state.records[props.rowIndex][p.FilterField] == p.FilterValue);
        }
        if (this.editable && !this.isSummaryRowOnClick(props, this.parentField.Value)) {
          return <div style={{ width: '100%' }}>
            <Dropdown className='within-table' aria-label={lovOptions.map(p => p.description)} aria-labelledby={props.field} 
            options={lovOptions} 
            optionLabel="description" 
            optionValue="code" 
            value={this.state.records[props.rowIndex][props.field] ? this.state.records[props.rowIndex][props.field].toString() : null} 
            onChange={this.onDropdownChange} /></div>
        } else {
          let val = lovOptions.find(p => p.code == this.state.records[props.rowIndex][props.field])
          return <div>{val.description} </div>
        }
      case 'Date':
        if (this.editable && !this.isSummaryRowOnClick(props, this.parentField.Value)) {
          return (
            <div>
              <Calendar value= {this.state.records[props.rowIndex][props.field]? new Date(this.state.records[props.rowIndex][props.field]):null} onChange={(e) => this.onEditorDateChange(props, e)} />
            </div>
          );
        } else {
          return <div>
            {this.state.records[props.rowIndex][props.field] ? new Date(this.state.records[props.rowIndex][props.field]).toLocaleDateString() : null}
          </div>
        }
      case "Checkbox":
        if (this.editable && !this.isSummaryRowOnClick(props, this.parentField.Value)) {
          return <div><Checkbox style={{ width: '100%', zIndex: '1000' }} 
          checked={this.state.records[props.rowIndex][props.field] || this.state.records[props.rowIndex][props.field] =='Y'} 
          onChange={(e) => this.onCheckboxValueChange(props, e)} /></div>
        }
      case 'Currency':
        if (this.editable && !this.isSummaryRowOnClick(props, this.parentField.Value)) {
          return <div style={{ textAlign: 'right' }}>
            <InputNumber type="text" value={this.state.records[props.rowIndex][props.field]} currency="USD" locale="en-US" onChange={(e) => this.onEditorValueChange(props, e)} />
          </div>

        } else {
          return <div style={{ textAlign: 'right' }}>{Number(this.state.records[props.rowIndex][props.field])} </div>
        }
      case "History":

        if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
          let arr = lengthAndRow.split(",");
          numOfRow = parseInt(arr[0].toString(), 10);
          maxLength = parseInt(arr[1].toString(), 10);
        }

        const fields = props.field.split(",");

        if (this.editable) {
          return <div>
            <label style={{ whiteSpace: 'pre-wrap' }}>{this.state.records[props.rowIndex][fields[0]]}</label>
            <p></p>
            <div>
              <InputTextarea style={{ width: '100%' }} readOnly={false} value={this.state.records[props.rowIndex][props.field]} maxLength={maxLength} rows={numOfRow} onChange={(e) => this.onEditorValueChange(props, e)} />
            </div>
          </div>
        } else {
          return <div style={{ whiteSpace: 'pre-wrap' }}>{this.state.records[props.rowIndex][props.field[0]]} </div>
        }

      case 'MultiText':
        lengthAndRow = this.ele.Length;
        if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
          let arr = lengthAndRow.split(",");
          numOfRow = parseInt(arr[0].toString(), 10);
          maxLength = parseInt(arr[1].toString(), 10);
        }

        if ((this.editable || this.props.usedByDesigner) && !this.isSummaryRowOnClick(props, this.parentField.Value)) {
          return <div>
            <InputTextarea disabled={this.props.usedByDesigner ? false : !this.editable} value={this.state.records[props.rowIndex][props.field]} maxLength={maxLength} rows={numOfRow} style={{ width: '100%' }} onChange={(e) => this.onEditorValueChange(props, e)} />
          </div>
        } else {
          return <div style={{ whiteSpace: 'pre-wrap', width: '100%' }}>{this.state.records[props.rowIndex][props.field]} </div>
        }

      default:
        let styleObj
        if (this.ele.EGMSStyle)
          styleObj = JSON.parse(this.ele.EGMSStyle);

        return (<div>
          <InputText value={this.state.records[props.rowIndex][props.field]} style={styleObj ? styleObj : null} maxLength={parseInt(this.ele.Length)} onChange={(e) => this.onEditorValueChange(props, e)} />
        </div>);

    }
  }

  generateTableContent = (subSection: FormSubSections) => {
    var controlArray = [];
    var elementIds = [];
    let addButton;

    addButton =
      <Button
        key={'BtnAdd_' + subSection.Id}
        label={this.props.isEng ? "Add " + subSection.parent.ENUTitle : 'ajouter ' + subSection.parent.FRATitle}
        onClick={this.OnAddClick}
      />;

    var columns = [];


    var elements = subSection.ListOfFormSectionElements;//.filter(item => item.visible);
    if (this.props.usedByDesigner) {
      elements = elements.filter(p => p.Editable == 'N');
    }

    let loadBindBase: string = "";
    let colNum = elements.length;

    elements.filter(p => p.ENUTitle != null).forEach((subelement, eleIndex) => {
      let name = subelement.ENUTitle;
      let columnId = (subelement.LoadBindBase ? subelement.LoadBindBase + '.' : '') + subelement.LoadBindName;
      let header;

      if (colNum > 1) {
        header = this.props.isEng ? subelement.ENUTitle : subelement.FRATitle;
      } else {
        header = this.props.editable ? addButton : null;
      }

      let rowSpan = 1;
      if (subelement.Datatype == 'MultiText') {
        rowSpan = 3;
      }

      let len = 150;
      let words = name?.split(' ');
      if (words.filter(p => p.length > 9).length > 0) {
        len = 9.2 * Utils.longestStrInArray(words).length;
      }

      if (this.props.editable && (subelement.Editable == 'Y' || this.props.usedByDesigner)) {
        let styleObj
        if (subelement.EGMSStyle) {
          styleObj = JSON.parse(subelement.EGMSStyle);
        }
        //console.log(subelement);
        columns.push(
          <Column 
            frozen={this.parentField.FreezeColumn == 'Y' && eleIndex == 0 ? true : false} 
            key={subelement.Id} 
            field={columnId} 
            header={header} 
            style={subelement.EGMSStyle ? styleObj : { width: subelement.colWidth? parseInt(subelement.colWidth) : len }} 
            editor={(options) => this.textEditor(options)} 
            body={this.inputTemplate}
          />
        )

      } else if (subelement.DisplayTooltipValue != null) {
        columns.push(
          <Column key={subelement.DisplayTooltipValue} 
            field={columnId} 
            header={header} 
            style={{ width: len }} 
            body={this.inputTemplateTooltip} 
          />
        );
        let obj = new ElementDictionary();
        obj.columnId = columnId;
        obj.subElement = subelement;
        this.loadingBody.push(obj);
      }
      //readonly columns
      else {
        if (subelement.Datatype == 'Date' || subelement.Datatype == 'MultiText' || subelement.Datatype == 'Dropdown' || subelement.Datatype == 'History' || subelement.Datatype == 'Checkbox') {
          columns.push(<Column key={subelement.Id} field={columnId} header={header} style={{ width: len }} body={this.inputTemplate} />);
        } else {
          columns.push(<Column sortable={false} filter={false} key={"col_" + subelement.Sequence} field={columnId} header={header} style={{ width: subelement.colWidth? subelement.colWidth : len }} />);
        }
      }
    });

    if (this.parentField.HasTotalColumn == 'Y')
      columns.push(<Column header="Total Cost" style={{ width: 78 }} field="totalCost" />);

    let tableHeader;

    if (colNum > 1 && this.props.editable && (this.props.activeSubSection.ListOfFormSectionElements.filter(p => p.Editable == 'N').length == 0 || this.props.usedByDesigner)) {
      columns.push(<Column key={"delete_" + subSection.Sequence} style={{ width: '20px' }} body={this.deleteTemplate} />);

      tableHeader = (
        <div key={'listfdHeader_div_' + subSection.Id} style={{ textAlign: 'center' }} >
          {addButton}
        </div>
      );
    }

    controlArray.push(
      (
        <div key={'fdTable_div_' + subSection.Id} style={{ width: '100%' }}>
          <DataTable 
            filterDisplay= { this.props.activeSubSection.parent["filterDisplay"] && this.props.activeSubSection.parent["filterDisplay"]=='Y'? "row":null}
            showGridlines 
            key={'BtnAdd_' + subSection.Id} 
            //value={this.state.records} 
            value={this.tableData}
            id={'table_' + loadBindBase} 
            header={tableHeader} 
            dataKey="id" 
            emptyMessage={null} 
            style={{ width: '100%' }} 
            scrollable 
            size="large" 
            resizableColumns 
            columnResizeMode="expand"
          >
            {columns}
          </DataTable>
        </div>
      )
    );
    controlArray.push(<br key={'br_' + this.props.activeSubSection.Id} />);
    return controlArray;
    // }
  }

  isSummaryRowOnView = (props, parentValue) => {
    let isSummary = false;

    for (let key in props) {
      if (props[key] == this.TOTAL_COLUMN_VALUE) {
        isSummary = true;
      }
    }
    return isSummary;
  }

  isSummaryRowOnClick = (props, parentValue) => {
    let isSummary = false;

    if (parentValue.length > 0) {
      for (let key in parentValue[props.rowIndex]) {
        if (parentValue[props.rowIndex][key] == this.TOTAL_COLUMN_VALUE) {
          isSummary = true;
        }
      }
    }
    // for(let key in col){
    //   if(col[key] == this.TOTAL_COLUMN_VALUE){
    //     isSummary = true;
    //   }
    // }
    return isSummary;
  }

  render() {
    let sectionPanelContents = this.generateTableContent(this.props.activeSubSection);
    return (
      <div key={'dynamicSec_' + this.props.activeSubSection.Id} style={{ width: '100%' }}>
        {sectionPanelContents}
      </div >
    );
  }
}
